export const convertScientificNumberToText = function(n: any): string {
  if (`${n}`.indexOf('e') > -1) {
    n = n.toLocaleString('fullwide', { useGrouping: false });
  }
  return `${<string>n}`;
};
